const actionTypes = {
  SET_DIRECT_SEND_DETAIL: 'setDirectSendDetail',
  SET_PARAMS: 'setDirectlSendParams',
  SET_TOTAL_COUNT: 'setDirectSendTotalCount',
  SET_DIRECT_SEND_CHOOSED_DETAIL: 'setDirectSendChoosedDetail',
  SET_CORPORATE_NAME: 'setDirectSendCorpprateName',
}
export default actionTypes
